import { styled, Typography, useTheme } from '@mui/material';
import type { BoxProps } from '@mui/material';
import { GridLegacy as Grid } from '@mui/material';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { EnvelopeIcon, InformationCircleIcon, PhoneIcon } from 'src/icons';
import { Link } from 'src/lib/components/Link';

const DummyBox = styled(Box)<BoxProps>(({ theme: _theme }) => ({
    opacity: 0,
    pointerEvents: 'none',
}));


const StyledBox = styled(Box)<BoxProps>(({ theme: _theme }) => ({
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
}));

const StyledIconBox = styled(Box)<BoxProps>(({ theme: _theme }) => ({
    fontSize: '16px',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    gap: _theme.spacing(1),
}));

const FooterContents = () => {
    const { t } = useTranslation('auth.login');
    const theme = useTheme();
    return (
        <Grid
            container
            padding={2}
            gap={{ xs: 1, md: 2 }}
            direction={{ xs: 'column', md: 'row' }}
            justifyContent="center"
            alignItems="center"
            bgcolor={theme.resqPalette.surface.hovered}
            borderTop={`1px solid ${theme.resqPalette.border.subdued}`}
        >
            <Grid item>
                <Typography variant="h4">{t('needHelpLoggingIn')}</Typography>
            </Grid>
            <Grid item>
                <StyledIconBox>
                    <PhoneIcon height="20px" />
                    <Link
                        to={t('hrefResqNumber')}
                        trackingId="login_help_banner_phone"
                        sx={{
                            color: theme.resqPalette.text.primary,
                            fontWeight: 600,
                        }}
                    >
                        {t('resqNumber')}
                    </Link>
                </StyledIconBox>
            </Grid>
            <Grid item>
                <StyledIconBox>
                    <EnvelopeIcon height="20px" />
                    <Link
                        to={t('hrefResqEmail')}
                        trackingId="login_help_banner_email"
                        sx={{
                            color: theme.resqPalette.text.primary,
                            fontWeight: 600,
                        }}
                    >
                        {t('resqEmail')}
                    </Link>
                </StyledIconBox>
            </Grid>
            <Grid item>
                <StyledIconBox>
                    <InformationCircleIcon height="20px" />
                    <Link
                        to={t('hrefResqTOS')}
                        trackingId="login_help_banner_tos"
                        sx={{
                            color: theme.resqPalette.text.primary,
                            fontWeight: 600,
                        }}
                    >
                        {t('resqTOS')}
                    </Link>
                </StyledIconBox>
            </Grid>
        </Grid>
    );
};

export const ContactFooter = () => {
    const { t: _t } = useTranslation('auth.login');
    return (
        <>
            {/* Dummy Footer to leave space at the bottom of the page */}
            <DummyBox component="footer">
                <FooterContents />
            </DummyBox>
            <StyledBox component="footer">
                <FooterContents />
            </StyledBox>
        </>
    );
};
